import {useEffect, useState} from "react";
import {DocumentFile} from "../../services/interface/DocumentFile";
import {useFindDocument} from "../../services/document/apiDocument";
import {DocumentProcessInterface} from "../../services/interface/DocumentProcessInterface";

interface Props {
    documentItem?: DocumentProcessInterface
}
export const useDocumentService = ({documentItem}: Props) => {
    const {mutate: findDocument, isPending: isLoadingDocument, data: successFindDocument} = useFindDocument();

    const [file, setFile] = useState<DocumentFile | undefined>()

    useEffect(() => {
        if (successFindDocument) {
            const mime = documentItem?.type;
            if (mime === "application/pdf") {
                // Para PDF o imágenes, seguir mostrándolos
                const archive = {
                    fileDocumentView: `data:${mime};base64,${successFindDocument.file}`,
                    typeFile: mime
                };
                setFile(archive);
            } else {
                const byteCharacters = atob(successFindDocument.file);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], { type: mime });
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = documentItem?.name || "file.zip"; // Usa el nombre real si lo tienes
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }, [successFindDocument]);

    return { findDocument, isLoadingDocument, file }
}
